/**
 * Convert to array for CSV content only, without header
 */
export function csvContentToArray(str, headers, delimiter = ',') {
  const rows = str.split('\n');

  const arr = rows.map((row) => {
    const values = row.split(delimiter);
    const el = headers.reduce((object, header, index) => {
      object[header] = values[index];
      return object;
    }, {});
    return el;
  });

  return arr;
}

export function csvToArray(str, delimiter = ',') {
  const headers = str.slice(0, str.indexOf('\n')).split(delimiter);
  const rowsStr = str.slice(str.indexOf('\n') + 1);

  return csvContentToArray(rowsStr, headers, delimiter);
}
